// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2YulY","content":"GlobalSearch_content__2SYiX"};